import useGlobalContext from "./useGlobalContext.js";
import { isOfKayakOrigin } from "../utils/marketing-url-params.js";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import useRetryFlightDetailsApi from "./useRetryFlightDetailsApi.js";
const useKayakS2SParams = (fetchStatus, flight, landingMetaOffer, searchParams, params) => {
    const { marketingTrackingVariables } = useGlobalContext();
    const { isRetryableFlightDetails } = useRetryFlightDetailsApi();
    if (isOfKayakOrigin() &&
        (fetchStatus === "success" || fetchStatus === "failed") &&
        params?.id === landingMetaOffer &&
        marketingTrackingVariables?.externalTracking &&
        !flightsSessionStore.get("kayak_s2s_fired")) {
        marketingTrackingVariables.externalOrigin &&
            searchParams.set("externalOrigin", marketingTrackingVariables.externalOrigin);
        searchParams.set("extTr", marketingTrackingVariables.externalTracking);
        searchParams.set("resultType", fetchStatus === "failed" && !(flight && isRetryableFlightDetails()) ? "not_found" : "found");
        flightsSessionStore.set("kayak_s2s_fired", true);
    }
};
export default useKayakS2SParams;
